<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y v-if="user.role.roleName != 'PROCUREMENT_MANAGER'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on">
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="openDialog = true">
                <v-list-tile-content>
                  <v-list-tile-title>IMPORT EXCEL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="printAllButtonLoading"
                v-bind="attrs"
                v-on="on"
                ><v-icon>cloud_download</v-icon>Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile @click="printAllStockIn('printStockIn')">
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="exportAllStockIn()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex
              sm4
              v-if="
                user.role.roleName == 'ADMIN' ||
                  (user.role.roleName == 'PROCUREMENT_MANAGER' &&
                    !user.warehouseId)
              "
            >
              <v-select
                :items="warehouseList"
                label="Choose Warehouse..."
                item-text="name"
                menu-props="auto"
                item-value="id"
                v-model="queryParams.warehouseId"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="stockInStatusList"
                label="Choose Stock In Status ..."
                :hide-no-data="true"
                color="blue-grey lighten-2"
                item-text="label"
                item-value="value"
                menu-props="auto"
                v-model="queryParams.status"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="typeList"
                label="Choose Stock In Type ..."
                :hide-no-data="true"
                color="blue-grey lighten-2"
                item-text="label"
                item-value="value"
                menu-props="auto"
                v-model="queryParams.type"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="issueNo"
                label="Issue No"
                type="text"
                v-model="queryParams.issueNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="serialNo"
                label="GR No"
                type="text"
                v-model="queryParams.serialNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="poNo"
                label="PO No"
                type="text"
                v-model="queryParams.poNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="stockInList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-btn
                  flat
                  icon
                  color="blue lighten-2"
                  @click="onEdit(props.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
              <td>{{ props.item.warehouse.name }}</td>
              <td v-if="props.item.bin">{{ props.item.bin.name }}</td>
              <td v-else></td>
              <td>
                {{ props.item.issueDateInMilliSeconds | formatMsDate }}
              </td>
              <td>{{ props.item.issueNo }}</td>
              <td>{{ props.item.serialNo }}</td>
              <td>{{ props.item.poNo }}</td>
              <td>{{ props.item.type }}</td>
              <td>{{ props.item.status }}</td>
              <td>{{ props.item.description }}</td>
              <td>
                {{ props.item.updatedDateInMilliSeconds | formatMsDateTime }}
              </td>
              <td>{{ props.item.updatedBy }}</td>
              <td>
                <v-btn
                  color="primary"
                  @click.stop="reprintStockInInvoice(props.item.id)"
                  :loading="reprintLoading"
                >
                  REPRINT
                </v-btn>
              </td>
              <td>
                <v-btn color="success" @click.stop="exportExcel(props.item.id)">
                  EXPORT
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- dialog -->
    <stockInExcel
      :isOpen="openDialog"
      v-on:change="dialogClose()"
    ></stockInExcel>
    <div
      id="printStockIn"
      style="border: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 18px; margin: 1px">Stock In Report</p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          From Date: [{{ this.queryParams.fromDate | formatDate }}] To Date: [{{
            this.queryParams.toDate | formatDate
          }}]
        </p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 14px; margin: 1px">
          Reported Date: [{{ reportedDate }}]
        </p>
      </div>
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 12px;
            border-top: 1px solid black;
          "
        >
          <thead style="border: 1px solid black">
            <tr>
              <th style="border: 1px solid black; text-align: center">
                Issue Date
              </th>
              <th style="border: 1px solid black; text-align: center">
                Issue No
              </th>
              <th style="border: 1px solid black; text-align: center">GR No</th>
              <th style="border: 1px solid black; text-align: center">PO No</th>
              <th style="border: 1px solid black; text-align: center">
                Warehouse
              </th>
              <th style="border: 1px solid black; text-align: center">Bin</th>
              <th style="border: 1px solid black; text-align: center">
                Product Name
              </th>
              <th style="border: 1px solid black; text-align: center">Unit</th>
              <th style="border: 1px solid black; text-align: center">Qty</th>
            </tr>
          </thead>
          <tbody style="border: 1px solid black">
            <tr v-for="(item, index) in allStockInList" :key="index">
              <td
                valign="top"
                style="border: 1px solid black; text-align: left"
              >
                {{ item.issueDateInMilliSeconds | formatMsDate }}
              </td>
              <td
                valign="top"
                style="border: 1px solid black; text-align: left"
              >
                {{ item.issueNo }}
              </td>
              <td
                valign="top"
                style="border: 1px solid black; text-align: left"
              >
                {{ item.serialNo }}
              </td>
              <td
                valign="top"
                style="border: 1px solid black; text-align: left"
              >
                {{ item.poNo }}
              </td>
              <td
                valign="top"
                style="border: 1px solid black; text-align: left"
              >
                {{ item.warehouse.name }}
              </td>
              <td
                valign="top"
                style="border: 1px solid black; text-align: left"
                v-if="item.bin"
              >
                {{ item.bin.name }}
              </td>
              <td valign="top" style="border: 1px solid black" v-else></td>
              <td
                valign="top"
                style="border: 1px solid black; text-align: left"
              >
                <div
                  style="height: 2rem"
                  v-for="detail in item.stockInItems"
                  :key="detail"
                >
                  {{ detail.productName + "(" + detail.productCode + ")" }}
                  <br />
                </div>
              </td>
              <td
                valign="top"
                style="border: 1px solid black; text-align: center"
              >
                <div
                  style="height: 2rem"
                  v-for="detail in item.stockInItems"
                  :key="detail"
                >
                  {{ detail.factorUnitName }} <br />
                </div>
              </td>
              <td
                valign="top"
                style="border: 1px solid black; text-align: right"
              >
                <ul style="list-style-type: none">
                  <li
                    style="height: 2rem"
                    v-for="detail in item.stockInItems"
                    :key="detail"
                  >
                    {{ detail.qty | decFormat(6) }}
                  </li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </v-container>
</template>

<script>
import { stockInService } from "../../services/stockin-service";
import { warehouseService } from "../../services/warehouse-service";
import { commonService } from "../../services/common-service";
import stockInExcel from "../../components/stockin/StockInExcel";

export default {
  name: "StockInList",

  components: { stockInExcel },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    showFilters: false,
    issueDate: "",
    breadcrumbs: [
      {
        text: "Warehouse Management",
        disabled: true,
      },
      {
        text: "Stock In",
        disabled: true,
      },
    ],
    headers: [
      { text: "Action", value: "name", sortable: false },
      { text: "Warehouse Name", align: "left", value: "warehouse.name" },
      { text: "Bin Name", align: "left", value: "bin.name" },
      { text: "Issue Date", value: "issueDate" },
      { text: "Issue No", value: "issueNo" },
      { text: "GR No", value: "serialNo" },
      { text: "PO No", value: "poNo" },
      { text: "Stock In Type", value: "type" },
      { text: "Stock In Status", value: "status" },
      { text: "Description", value: "description" },
      { text: "Updated  Date", value: "updatedDate" },
      { text: "Updated  By", value: "updatedBy" },
      { text: "Reprint", align: "center", sortable: false },
      { text: "Export", align: "center", sortable: false },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    stockInStatusList: [
      { label: "---All---", value: "" },
      { label: "DRAFT", value: "DRAFT" },
      { label: "FINISHED", value: "FINISHED" },
      { label: "CANCEL", value: "CANCEL" },
    ],
    typeList: [
      { label: "---All---", value: "" },
      { label: "PURCHASING", value: "PURCHASING" },
      { label: "STORE_RETURN", value: "STORE_RETURN" },
      { label: "FOC", value: "FOC" },
      { label: "RENTAL", value: "RENTAL" },
      { label: "DONATION", value: "DONATION" },
      { label: "TRANSFER", value: "TRANSFER" },
      { label: "OPENING", value: "OPENING" },
      { label: "PRODUCTION", value: "PRODUCTION" },
    ],
    printAllButtonLoading: false,
    stockInList: [],
    allStockInList: [],
    warehouseList: [],
    openDialog: false,
    totalRows: 0,
    reportedDate: commonService.formatDate(new Date(), "DD/MM/YYYY"),
    queryParams: {
      warehouseId: "",
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      issueNo: "",
      serialNo: "",
      poNo: "",
      status: "",
      type: "",
      updateUserId: "",
      binIds: [],
    },
    reprintLoading: false,
  }),
  watch: {
    pagination: {
      handler() {
        this.getStockInList();
      },
      deep: true,
    },
  },
  created() {
    let user = JSON.parse(localStorage.getItem("user"));
    if (
      user.role.roleName == "WAREHOUSE_MANAGER" ||
      user.role.roleName == "WAREHOUSE_STAFF" ||
      user.roleName == "BRANCH_ADMIN" ||
      user.role.roleName == "PROCUREMENT_MANAGER"
    ) {
      this.queryParams.warehouseId = user.warehouseId;
      if (user.role.roleName == "WAREHOUSE_STAFF") {
        user.selectedBinList.forEach((v) => this.queryParams.binIds.push(v.id));
      }
    } else if (
      user.role.roleName == "SALE_MANAGER" ||
      user.role.roleName == "GENERAL_MANAGER" ||
      user.role.roleName == "PRODUCTION_MANAGER"||
      user.role.roleName == "ASSET_MANAGER"
    ) {
      this.queryParams.warehouseId = user.shop.warehouseId;
      if (user.role.roleName == "SALE_MANAGER") {
        this.queryParams.updateUserId = user.id;
      }
    }
    //for deep linking
    if (this.$route.query.warehouseId) {
      this.queryParams.warehouseId = Number(this.$route.query.warehouseId);
    }
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.issueNo) {
      this.queryParams.issueNo = this.$route.query.issueNo;
    }
    if (this.$route.query.serialNo) {
      this.queryParams.serialNo = this.$route.query.serialNo;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.type) {
      this.queryParams.type = this.$route.query.type;
    }
    if (this.$route.query.updateUserId) {
      this.queryParams.updateUserId = Number(this.$route.query.updateUserId);
    }
    if (this.$route.query.poNo) {
      this.queryParams.poNo = this.$route.query.poNo;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getWarehouseList();
    this.getStockInList();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "stockins", query: this.queryParams });
      this.getStockInList();
    },
    getWarehouseList() {
      warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.warehouseList = res.data;
          let findAll = {
            id: "",
            name: "---All---",
          };
          this.warehouseList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    printAllStockIn(divName) {
      this.printAllButtonLoading = true;
      stockInService
        .getAllStockInList(this.queryParams)
        .then((res) => {
          if (res.data) {
            this.allStockInList = res.data.stockInList;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.printAllButtonLoading = false;
        });
    },
    getStockInList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      stockInService
        .getStockInList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.stockInList = res.data.stockInList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onRegister() {
      this.$router.push("/stockin/new");
    },
    dialogClose() {
      this.openDialog = false;
      this.getStockInList();
    },
    onEdit(stockin) {
      // go to details page
      this.$router.push("/stockin/" + stockin.id);
    },
    reprintStockInInvoice(id) {
      this.reprintLoading = true;
      stockInService.printStockInInvoice(id).then((res) => {
        var blob = res;
        stockInService.showWindowDialog(blob, "invoice-" + id);
        this.reprintLoading = false;
      });
    },
    exportAllStockIn() {
      this.printAllButtonLoading = false;
      stockInService
        .exportStockInHeaderDetailExcel(this.queryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.printAllButtonLoading = false;
        });
    },

    exportExcel(id) {
      stockInService
        .exportStockInExcel(id)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
